import { render, staticRenderFns } from "./RegisterAsBusiness.vue?vue&type=template&id=758483c5&scoped=true"
import script from "./RegisterAsBusiness.vue?vue&type=script&lang=ts"
export * from "./RegisterAsBusiness.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758483c5",
  null
  
)

export default component.exports